import { render, staticRenderFns } from "./organizationDetail.vue?vue&type=template&id=a86cc4e6&"
import script from "./organizationDetail.vue?vue&type=script&lang=ts&"
export * from "./organizationDetail.vue?vue&type=script&lang=ts&"
import style0 from "./organizationDetail.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports